export enum Stage {
  Starting,
  InProgress,
  Completed,
}
